module.exports = __webpack_public_path__ + "img/UI_shouji_saomiao_01_e7408ac7d.png";